
<div v-if="collection">
  <align class="header" flex>
    <align small-gap>
      <h3 class="secondary-font">
        {{ collectionName }}
      </h3>

      <dropdown
        v-if="collectionOptions.length"
        :align="bottom ? 'top-left' : 'center'"
        :active="menuOpen"
        @close="menuOpen = false"
      >
        <icon-button icon="expand_more" @click="menuOpen = !menuOpen" />

        <template #menu>
          <dropdown-menu
            :options="collectionOptions"
            @select="switchCollection"
          />
        </template>
      </dropdown>
    </align>

    <icon-link as="router-link" :to="`/collection?id=${collectionId}`">
      View Collection
    </icon-link>
  </align>

  <div class="grid">
    <stat-item
      size="xlarge"
      :success="collectionStats.dailyDollarChange > 0"
      :error="collectionStats.dailyDollarChange < 0"
      label="Daily $ Change"
      :value="`${collectionStats.dailyDollarChange > 0 ? '+' : ''}${$filters.currency(collectionStats.dailyDollarChange)}`"
    />

    <stat-item
      size="xlarge"
      :success="collectionStats.dailyPercentChange > 0"
      :error="collectionStats.dailyPercentChange < 0"
      label="Daily % Change"
      :value="`${collectionStats.dailyPercentChange > 0 ? '+' : ''}${$filters.percentage(collectionStats.dailyPercentChange)}`"
    />

    <stat-item
      size="xlarge"
      success
      label="Total Value"
      :value="$filters.currency(collection.totalValue)"
    />

    <stat-item
      size="xlarge"
      :success="collectionStats.profit > 0"
      :error="collectionStats.profit < 0"
      label="Potential Profit"
      :value="`${collectionStats.profit > 0 ? '+' : ''}${$filters.currency(collectionStats.profit)}`"
    />
  </div>
</div>
